import { RouteConfig } from 'vue-router';
import store from '@/store';

/**
 * 是否有路由权限
 * @param roles
 * @param route
 */
export const isHasRoutePermission = function(roles: string[], route: RouteConfig) {
  if (route && route.meta && route.meta.permission && route.meta.permission.page) {
    return roles.some(role => route.meta!.permission.page.indexOf(role) >= 0);
  }

  return false;
};

/**
 * 同步路由
 * @param route
 */
export const generateRoutes = function(routes: RouteConfig[]): RouteConfig[] {
  const generate = routes.filter(route => {
    if (route && route.meta && route.meta.permission) {
      let has = isHasRoutePermission(store.state.user.roles, route);

      if (has) {
        if (route.children && route.children.length > 0) {
          const children = generateRoutes(route.children);
          route.children = children;
        }
        return true;
      } else {
        return false;
      }
    }
    return true;
  });
  return generate;
};
